import React from 'react';

import type { IIcon } from '../types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 30, className, onClick }, ref) {
  return (
    <svg ref={ref} viewBox='0 0 512 512' onClick={onClick} width={size} height={size} className={className}>
      <path fill='#E2E5E7' d='M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z' />
      <path fill='#B0B7BD' d='M384,128h96L352,0v96C352,113.6,366.4,128,384,128z' />
      <polygon fill='#CAD1D8' points='480,224 384,128 480,128 ' />
      <path fill='#84BD5A' d='M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z' />
      <g>
        <path
          fill='#FFFFFF'
          d='M55.68,376.064v-72.656c0-4.608,3.328-7.936,9.072-7.936c4.48,0,7.808,3.328,7.808,7.936v27.888 h41.696v-27.888c0-4.608,4.096-7.936,8.704-7.936c4.48,0,7.936,3.328,7.936,7.936v72.656c0,4.48-3.456,7.936-7.936,7.936 c-4.608,0-8.704-3.456-8.704-7.936v-28H72.56v28c0,4.48-3.328,7.936-7.808,7.936C59.008,384,55.68,380.544,55.68,376.064z'
        />
        <path
          fill='#FFFFFF'
          d='M172.784,311.472H150.4c-11.136,0-11.136-16.368,0-16.368h60.496c11.392,0,11.392,16.368,0,16.368 h-21.232v64.592c0,11.12-16.896,11.392-16.896,0v-64.592H172.784z'
        />
        <path
          fill='#FFFFFF'
          d='M248.688,327.84v47.328c0,5.648-4.608,8.832-9.2,8.832c-4.096,0-7.68-3.184-7.68-8.832v-72.016 c0-6.656,5.648-8.848,7.68-8.848c3.696,0,5.872,2.192,8.048,4.624l28.16,37.984l29.152-39.408c4.24-5.232,14.592-3.2,14.592,5.648 v72.016c0,5.648-3.6,8.832-7.68,8.832c-4.592,0-8.192-3.184-8.192-8.832V327.84l-21.232,26.864c-4.592,5.648-10.352,5.648-14.576,0 L248.688,327.84z'
        />
        <path
          fill='#FFFFFF'
          d='M337.264,303.152c0-4.224,3.584-7.808,8.064-7.808c4.096,0,7.552,3.6,7.552,7.808v64.096h34.8 c12.528,0,12.8,16.752,0,16.752h-42.336c-4.48,0-8.064-3.184-8.064-7.808v-73.04H337.264z'
        />
      </g>
      <path fill='#CAD1D8' d='M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z' />
    </svg>
  );
});

export default React.memo(Icon);
